import {subCompare} from "./utilities";

export const doChapterSearch = (book, rendition, cfi) => {
  let spine =  book.spine.get(cfi)
  return book.navigation.get(spine.href)
};

export const createBookID = (str) => {
  let toLatin = transliterate(str)
  return toLatin.toLowerCase().replace(/[ ']/g, '_')
}

const transliterate = function(text) {
  return text
    .replace(/\u0401/g, 'YO')
    .replace(/\u0419/g, 'I')
    .replace(/\u0426/g, 'TS')
    .replace(/\u0423/g, 'U')
    .replace(/\u041A/g, 'K')
    .replace(/\u0415/g, 'E')
    .replace(/\u041D/g, 'N')
    .replace(/\u0413/g, 'G')
    .replace(/\u0428/g, 'SH')
    .replace(/\u0429/g, 'SCH')
    .replace(/\u0417/g, 'Z')
    .replace(/\u0425/g, 'H')
    .replace(/\u042A/g, '')
    .replace(/\u0451/g, 'yo')
    .replace(/\u0439/g, 'i')
    .replace(/\u0446/g, 'ts')
    .replace(/\u0443/g, 'u')
    .replace(/\u043A/g, 'k')
    .replace(/\u0435/g, 'e')
    .replace(/\u043D/g, 'n')
    .replace(/\u0433/g, 'g')
    .replace(/\u0448/g, 'sh')
    .replace(/\u0449/g, 'sch')
    .replace(/\u0437/g, 'z')
    .replace(/\u0445/g, 'h')
    .replace(/\u044A/g, "'")
    .replace(/\u0424/g, 'F')
    .replace(/\u042B/g, 'I')
    .replace(/\u0412/g, 'V')
    .replace(/\u0410/g, 'a')
    .replace(/\u041F/g, 'P')
    .replace(/\u0420/g, 'R')
    .replace(/\u041E/g, 'O')
    .replace(/\u041B/g, 'L')
    .replace(/\u0414/g, 'D')
    .replace(/\u0416/g, 'ZH')
    .replace(/\u042D/g, 'E')
    .replace(/\u0444/g, 'f')
    .replace(/\u044B/g, 'i')
    .replace(/\u0432/g, 'v')
    .replace(/\u0430/g, 'a')
    .replace(/\u043F/g, 'p')
    .replace(/\u0440/g, 'r')
    .replace(/\u043E/g, 'o')
    .replace(/\u043B/g, 'l')
    .replace(/\u0434/g, 'd')
    .replace(/\u0436/g, 'zh')
    .replace(/\u044D/g, 'e')
    .replace(/\u042F/g, 'Ya')
    .replace(/\u0427/g, 'CH')
    .replace(/\u0421/g, 'S')
    .replace(/\u041C/g, 'M')
    .replace(/\u0418/g, 'I')
    .replace(/\u0422/g, 'T')
    .replace(/\u042C/g, "'")
    .replace(/\u0411/g, 'B')
    .replace(/\u042E/g, 'YU')
    .replace(/\u044F/g, 'ya')
    .replace(/\u0447/g, 'ch')
    .replace(/\u0441/g, 's')
    .replace(/\u043C/g, 'm')
    .replace(/\u0438/g, 'i')
    .replace(/\u0442/g, 't')
    .replace(/\u044C/g, "'")
    .replace(/\u0431/g, 'b')
    .replace(/\u044E/g, 'yu');
}

export const findInSection = (section, label) => {
  let queryString = label.trim().split(' ')
  let removeIndex = 0
  let result = []
  let str = []

  if (!section.find) return result

  for(let q of queryString) {
    str[q] = removeIndex === 0 ? queryString : queryString.slice(0, -1 * removeIndex)
    str[q] = str[q].join(' ')
    result = section.find.bind(section, str[q])()
    if (result.length > 0) {
      break
    } else {
      removeIndex++
    }
  }

  if (result.length === 0) {
    queryString = label.trim().split(' ')
    removeIndex = queryString.length
    str = []
    for(let i=queryString.length; i>0; i--) {
      if ( queryString.length > 2 && removeIndex !== label.trim().split(' ').length ) {
        queryString.pop()
        queryString.shift()
      }
      str[i] = queryString
      str[i] = str[i].join(' ')
      result = section.find.bind(section, str[i])()
      if (result.length > 0) {
        break
      } else {
        removeIndex--
      }
    }
  }
  return result
}

export const createCfiRange = (highlight) => {
  if (!highlight.quotation || !highlight.quotation.begin || !highlight.quotation.end) return
  let begin = getCfi(highlight.quotation.begin)
  let end = getCfi(highlight.quotation.end)
  if (!begin || !end) return

  let baseCfi = subCompare(begin, end).substring.split('/').slice(0,-1).join('/')
  let beginCfi = begin.split(baseCfi)[1].slice(0,-1)
  let endCfi = end.split(baseCfi)[1].slice(0,-1)

  return baseCfi + ',' + beginCfi + ',' + endCfi + ')'
}


export const getCfi = (str) => {
  if (!str) return false
  let cfi = str.indexOf('##') > -1 ?
    str.split('#')[2] : str.indexOf('#') > -1 ? str.split('#')[1] : false
  if (cfi && cfi.split('/').length <= 3) return false
  return cfi
}


// WEBPACK FOOTER //
// ./src/utilities/epubUtilities.js